import { Component, OnInit } from '@angular/core';
import {CategoryListItem, CategoryService} from "../../../admin/products/categories/categories.service";
import {NavigationEnd, Router} from "@angular/router";
import {filter} from "rxjs/operators";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'app-nav-header',
  templateUrl: './nav-header.component.html',
  styleUrls: ['./nav-header.component.css'],
  providers:[CategoryService]
})
export class NavHeaderComponent implements OnInit {


  breadcrumbs: { label: string, url: string}[] = [];

  constructor(private router: Router, public categoryService: CategoryService, public translate:TranslateService,) {
    this.router.events
        .pipe(filter(event => event instanceof NavigationEnd))
        .subscribe(() => {

        });
  }

  updateBreadcrumbs(categories: CategoryListItem[]) {
    const urlSegments = this.router.url.split('/').filter(Boolean);
    let url = '';
    this.breadcrumbs = urlSegments.map((segment, index) => {
      url += '/' + segment;
      const cateKey = segment.replace(/-/g, ' ').toUpperCase()
      const crumbName = categories[cateKey]!= null? categories[cateKey].name : "N/A";
      return {
        label: this.capitalize(crumbName),
        url
      };
    });
    this.breadcrumbs = this.breadcrumbs.filter(crumb=> crumb.label != "N/A")
    // Optionally, add 'Home' at the start
    this.breadcrumbs.unshift({ label: this.translate.instant('sale4you.label.link.homePage'), url: '/' });
  }

  private capitalize(str: string) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  ngOnInit(): void {
    this.categoryService.getCategories().subscribe(categories => {
      this.updateBreadcrumbs(categories);
      // Use your categories here
    })
  }

}
